import { render } from "./MultiStepForm.vue?vue&type=template&id=889eb89c&scoped=true"
import script from "./MultiStepForm.vue?vue&type=script&lang=js"
export * from "./MultiStepForm.vue?vue&type=script&lang=js"

import "./MultiStepForm.vue?vue&type=style&index=0&id=889eb89c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889eb89c"]])

export default __exports__